import React, { ReactNode } from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import "./turnableCard.scss";

export interface TurnableCardProps {
  slots: {
    id: string;
    name: string;
    component: ReactNode;
  }[];
  onSlotChange?: (slotId: string) => void;
}

function TurnableCard({
  slots,
  onSlotChange,
}: TurnableCardProps & WrappedComponentProps) {
  const [turnDegrees, setTurnDegrees] = React.useState(0);
  const [activeSlotIndex, setActiveSlotIndex] = React.useState(0);

  const handlePreviousSlot = () => {
    setTurnDegrees((prev) => prev - 180);
    setTimeout(() => {
      setActiveSlotIndex((prev) => (prev - 1 + slots.length) % slots.length);
    }, 300);
  };

  const handleNextSlot = () => {
    setTurnDegrees((prev) => prev + 180);
    setTimeout(() => {
      setActiveSlotIndex((prev) => (prev + 1) % slots.length);
    }, 300);
  };

  const handleGoToSlot = (index: number) => {
    setTurnDegrees((prev) => {
      if (index > activeSlotIndex) {
        return prev + 180;
      } else if (index < activeSlotIndex) {
        return prev - 180;
      }
      return prev;
    });
    setTimeout(() => {
      setActiveSlotIndex(index);
    }, 400);
  };

  const getRotateStyle = (): React.CSSProperties => {
    return {
      transform: `rotateY(${-turnDegrees}deg)`,
      transition: "transform 1s cubic-bezier(0.4, 0, 0.2, 1)",
    };
  };

  const getCounterRotateStyle = (): React.CSSProperties => {
    return {
      transform: `rotateY(${turnDegrees}deg)`,
      transition: "transform 1s cubic-bezier(0.4, 0, 0.2, 1)",
    };
  };

  return (
    <div className="turnable-card" style={getRotateStyle()}>
      <div className="turnable-card-content" style={getCounterRotateStyle()}>
        {slots[activeSlotIndex].component}
      </div>
      <div className="turnable-card-footer" style={getCounterRotateStyle()}>
        {slots.map((slot, index) => (
          <div
            key={index}
            title={slot.name}
            className={`turnable-card-footer-item ${
              index === activeSlotIndex ? "active" : "inactive"
            }`}
            onClick={() => {
              handleGoToSlot(index);
              if (onSlotChange) {
                onSlotChange(slot.id);
              }
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default injectIntl(TurnableCard);
